import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: auto;
`

export const CircleSpacer = styled.span`
  margin-right: 5px;
  display: flex;
`

export const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${ (props) => props.size }px;
  width: ${ (props) => props.size }px;
  border-radius: 50%;
  font-size: ${ (props) => props.size - 4 }px;
  background: ${ (props) =>
    props.active
      ? props.theme.colors['aok-gruen']
      : props.theme.colors['icon-grau3'] };
  color: ${ (props) => props.theme.colors.weiss };

  @media print {
    color: #ffffff !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
`
